export const MOCK_VENDORS = [
  { id: "vend-1", name: "Supreme Electricals Ltd" },
  { id: "vend-2", name: "Apex Hydraulics & Valves" },
  { id: "vend-3", name: "Delta Cable Solutions" },
  { id: "vend-4", name: "Standard Industrial Pumps" },
];
